export default "__VITE_ASSET__CxFo$1Ee__";